import xw from 'xwind';
import { Button, styled } from '@mui/material';

export const shareButtonStyles = {
  button: xw`flex flex-col items-center focus:outline-none`,
  label: xw`hidden lg[inline text-sm text-black mt-3]`,
};

export const Wrapper = styled('div')`
  ${xw`flex`}
`;
export const SocialShareItem = styled('div')(xw`flex flex-col items-center`);

export const SocialShareItemLabel = styled('span')<{ hide?: boolean }>`
  ${shareButtonStyles.label};
`;

export const ToCommentsButton = styled(Button)`
  padding: 0;
  min-width: auto;
  .icons {
    font-size: ${({ theme }) => theme.spacing(5)};
  }
  ${({ theme }) => theme.breakpoints.up('sm')} {
    .icons {
      font-size: ${({ theme }) => theme.spacing(7.75)};
    }
  }
`;
